import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from './ui/button';

const CheckoutCancel = () => {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center space-y-8">
        <div className="w-20 h-20 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto">
          <XCircle className="w-12 h-12 text-orange-500" />
        </div>
        
        <div>
          <h1 className="text-4xl font-bold text-white mb-4">Payment Cancelled</h1>
          <p className="text-xl text-gray-400">Your order has not been processed</p>
        </div>

        <p className="text-gray-500">
          No charges have been made. You can return to our products page to continue shopping.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/#packages">
            <Button className="bg-cyan-500 hover:bg-cyan-400 text-black font-bold px-8 py-6 rounded-full w-full sm:w-auto">
              Back to Products
            </Button>
          </Link>
          
          <Link to="/#contact">
            <Button 
              variant="outline" 
              className="border-cyan-500 text-cyan-400 hover:bg-cyan-500/10 px-8 py-6 rounded-full w-full sm:w-auto"
            >
              Need Help?
            </Button>
          </Link>
        </div>

        <p className="text-gray-600 text-sm">
          Questions? Call us at 0490 792 050 (9am-5pm) or email efamfitness@gmail.com
        </p>
      </div>
    </div>
  );
};

export default CheckoutCancel;
